module.exports = __webpack_public_path__ + "static/media/slider-4.37526b79.jpeg";